import React, { useRef, useState } from 'react';
import { Button, Text } from 'src/@vymo/ui/atoms';
import { ReactComponent as ActiveIcon } from 'src/assets/icons/active.svg';
import { ReactComponent as Cross } from 'src/assets/icons/close.svg';
import { Keys, locale } from 'src/i18n';
import { useAppDispatch } from 'src/store/hooks';
import { setStatus, setUploadedFile, toggleRecording } from '../slice';
// import { MESSAGE_TYPE } from '../types';
import styles from '../index.module.scss';

function RecordingBanner() {
  const [recording, setRecording] = useState<boolean>(false);
  const mediaRecorderRef = useRef<any>(null);
  const chunksRef = useRef<any>([]);
  const dispatch = useAppDispatch();

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getDisplayMedia({
        video: {
          displaySurface: 'window',
        },
        audio: false,
      });

      const mediaRecorder = new MediaRecorder(stream, {
        mimeType: 'video/webm',
      });
      mediaRecorderRef.current = mediaRecorder;
      chunksRef.current = [];

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) chunksRef.current.push(e.data);
      };

      mediaRecorder.onstop = () => {
        const now = new Date();
        const formattedDate = `${now.getFullYear()}-${(now.getMonth() + 1)
          .toString()
          .padStart(2, '0')}-${now.getDate().toString().padStart(2, '0')}_${now
          .getHours()
          .toString()
          .padStart(2, '0')}-${now
          .getMinutes()
          .toString()
          .padStart(2, '0')}-${now.getSeconds().toString().padStart(2, '0')}`;
        const blob = new Blob(chunksRef.current, { type: 'video/webm' });
        const file = new File(
          [blob],
          `Screen Recording ${formattedDate}.webm`,
          { type: 'video/webm' },
        );
        setRecording(false);
        stream.getTracks().forEach((track) => track.stop());
        dispatch(setUploadedFile(file));
        dispatch(toggleRecording());
      };

      mediaRecorder.start();
      setRecording(true);
    } catch (err) {
      dispatch(
        setStatus({
          type: 'error',
          message: 'Screen recording permission denied or unsupported.',
        }),
      );
    }
  };

  const stopRecording = () => {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
  };

  return (
    <div className={styles.copilotv2__body__recording}>
      <ActiveIcon />
      <Text type="label">{locale(Keys.SCREEN_RECORDING_STARTED)}</Text>
      <Button
        type="primary"
        onClick={() => {
          if (recording) {
            stopRecording();
          } else {
            startRecording();
          }
          setRecording(!recording);
        }}
      >
        {recording ? 'Stop' : 'Start'}
      </Button>
      <Button
        size="small"
        type="text"
        disabled={recording}
        iconProps={{ icon: <Cross />, iconPosition: 'right' }}
        onClick={() => dispatch(toggleRecording())}
      />
    </div>
  );
}

export default RecordingBanner;
